import {
  type Contract,
  isBoolean,
  isObject,
  isString,
  maybeAsNumber,
  maybeBoolean,
  maybeString,
} from 'validata';
import { isObjectSet } from 'validata-mongo';
import type { Patrol } from './patrol.js';
import type { RequestContext } from './request-context.js';

export interface CheckedVehicle {
  color?: string;
  make?: string;
  model?: string;
  rego: string;
  reportedStolen?: boolean;
  type?: string;
  year?: number;
}

export interface CheckVehicleResponse extends CheckedVehicle {
  previousMentions: Patrol.Incident[];
}

export const checkedVehicleContract: Contract<CheckedVehicle> = {
  color: maybeString({ trim: 'both' }),
  make: maybeString({ trim: 'both' }),
  model: maybeString({ trim: 'both' }),
  rego: isString({ transform: (value) => value.toUpperCase(), trim: 'both' }),
  reportedStolen: maybeBoolean(),
  type: maybeString({ trim: 'both' }),
  year: maybeAsNumber(),
};

export namespace Vehicle {
  export const NAME = 'vehicle' as const;

  export interface Type {
    _id: string;
    color: string;
    created: RequestContext;
    hasLivery: boolean;
    make: string;
    model: string;
    organizationId: string;
    rego: string;
    retired?: RequestContext; // Soft delete flag
    updated: RequestContext;
  }

  export type Create = Pick<
    Type,
    'color' | 'hasLivery' | 'make' | 'model' | 'rego'
  >;

  export type Patch = Pick<Type, 'color' | 'hasLivery' | 'make' | 'model'>;

  export const createContract: Contract<Create> = {
    color: isString({ transform: (value) => value.trim(), trim: 'both' }),
    hasLivery: isBoolean(),
    make: isString({ trim: 'both' }),
    model: isString({ trim: 'both' }),
    rego: isString({
      maxLength: 6,
      minLength: 1,
      regex: /^[0-9a-zA-Z]+$/,
      transform: (value) => value.toUpperCase(),
      trim: 'both',
    }),
  };

  export const patchContract: Contract<Patch> = {
    color: isString({ transform: (value) => value.trim(), trim: 'both' }),
    hasLivery: isBoolean(),
    make: isString({ trim: 'both' }),
    model: isString({ trim: 'both' }),
  };

  export const create = isObject<Create>(createContract);
  export const patch = isObjectSet<Patch>(patchContract);
}
